/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
import { ApiResponse } from 'common/data/entities/api-response';
import { reqGet, reqPost } from 'common/data/remote/request';
import { Endpoints } from 'assets/Endpoints';
import { IDevice } from '../entities/device';
import { IWallboxReportExcelReq } from '../entities/report';

export class DeviceApiImpl {
	async getUserProducts(): Promise<IDevice[]> {
		try {
			const resp = await reqGet({
				url: Endpoints.USER_PRODUCTS,
			});
			const data = resp.data as ApiResponse<IDevice[]>;
			return data.data;
		} catch (error: any) {
			if (error.response) {
				const data = error.response.data as ApiResponse<void>;
				throw new Error(data.message);
			}
			throw new Error('An Error Occurred');
		}
	}

	async exportWallboxExcel(params: IWallboxReportExcelReq): Promise<Blob> {
		try {
			const resp = await reqPost({
				url: Endpoints.WALLBOX_EXCEL_EXPORT,
				responseType: 'blob',
				data: params,
			});
			const data = resp.data as Blob;
			return data;
		} catch (error) {
			throw error;
		}
	}

	async getUserProductTags(): Promise<ApiResponse<string[]>> {
		try {
			const resp = await reqGet({
				url: Endpoints.USER_PRODUCT_TAGS,
			});
			const data = resp.data as ApiResponse<string[]>;
			return data;
		} catch (error: any) {
			if (error.response) {
				const data = error.response.data as ApiResponse<void>;
				throw new Error(data.message);
			}
			throw new Error('An Error Occurred');
		}
	}
}
